import { useEffect } from 'react';

export const handleAppendArrowsToSliders = (
  nextTargetSelector: string,
  prevTargetSelector: string
) => {
  useEffect(() => {
    let intervalCounter = 0;
    let imgsAppended = false;

    const appendImages = () => {
      const nextTarget = document.querySelector(nextTargetSelector);
      const prevTarget = document.querySelector(prevTargetSelector);

      // check if img elements were already appended
      if (nextTarget?.querySelector("img") === null && prevTarget?.querySelector("img") === null) {
        // next img
        const next_img = document.createElement('img');
        next_img.src = "/img/rec-slider-arrow.svg";
        next_img.alt = "Next arrow";

        // prev img
        const prev_img = document.createElement('img');
        prev_img.src = "/img/rec-slider-arrow.svg";
        prev_img.alt = "Previous arrow";
        prev_img.style.transform = "rotate(180deg)";

        // append
        nextTarget?.appendChild(next_img);
        prevTarget?.appendChild(prev_img);

        // task complete
        imgsAppended = true;
      }
    };

    // run on load every second for 6 seconds
    const intervalTimer = setInterval(() => {
      if (!imgsAppended) {
        appendImages();
      }

      intervalCounter++;
      if (intervalCounter >= 6) {
        clearInterval(intervalTimer);
      }
    }, 1000); 

    // run on window resize 500ms after resize is done
    let resizeTimer: any;
    const onResize = () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        appendImages();
      }, 500);
    }

    window.addEventListener('resize', onResize);

    // cleanup
    return () => {
      clearInterval(intervalTimer);
      clearTimeout(resizeTimer);
      window.removeEventListener('resize', onResize);
    };
  }, [nextTargetSelector, prevTargetSelector]);
};
